<script setup lang="ts">
import { computed } from 'vue';
import { hasVeeValidationErrorsForPaths } from '../utils';
import { useFormErrors } from 'vee-validate';
import { warning } from '@/components/icons/icons.ts';

const props = defineProps<{
  paths: string[];
}>();

const formErrors = useFormErrors();

const hasErrors = computed(() => hasVeeValidationErrorsForPaths(formErrors.value, props.paths));
</script>

<template>
  <span :class="{ 'text-error': hasErrors }">
    <slot name="default" />
    <sup v-if="hasErrors" class="ml-1">
      <v-icon :icon="warning" size="small" />
    </sup>
  </span>
</template>
